import { KoButton } from 'packages';
import KoIcon from '@kwapio/icons';
import { useParams, useNavigate } from 'react-router-dom';
import styles from './monitoring.module.scss';

const TABS = [
  { key: 'overview', label: 'Overview', icon: 'DashboardOutlined' },
  { key: 'release-monitoring', label: 'Release Monitoring', icon: 'RocketOutlined' },
  { key: 'live-metrics', label: 'Live Metrics', icon: 'LineChartOutlined' },
  { key: 'logs', label: 'Log Explorer', icon: 'FileTextOutlined' },
  { key: 'alerts', label: 'Alerts', icon: 'AlertOutlined' },
  { key: 'incidents', label: 'Incidents', icon: 'ThunderboltOutlined' },
  { key: 'service-health', label: 'Service Health', icon: 'HeartOutlined' }
];

function MonitoringSubNav({ activeKey }) {
  const { workspaceId } = useParams();
  const navigate = useNavigate();

  const basePath = workspaceId
    ? `/workspace/${workspaceId}/development/monitoring`
    : '/monitoring';

  return (
    <div className={styles.subNav}>
      {TABS.map((tab) => (
        <KoButton
          key={tab.key}
          type={activeKey === tab.key ? 'primary' : 'text'}
          label={tab.label}
          icon={<KoIcon name={tab.icon} width={14} height={14} />}
          onClick={() => navigate(tab.key === 'overview' ? basePath : `${basePath}/${tab.key}`)}
          className={styles.subNavBtn}
        />
      ))}
    </div>
  );
}

export default MonitoringSubNav;
